import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="w-full bg-[#faf7f2] py-16 md:py-24" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4" data-id="element-73">
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-74">
          <p className="font-['Playfair_Display'] text-xl md:text-2xl lg:text-3xl text-[#1e293b] leading-relaxed italic" data-id="element-75">
            Son las 3 de la mañana. Estás sentada en la orilla de la cama, con
            los ojos ardiendo y el corazón acelerado, rogando en silencio que
            esta vez, al dejar a tu bebé en la cuna, no se despierte.
          </p>

          <div className="w-24 h-1 bg-[#d4a853] mx-auto my-8 md:my-12 rounded-full" data-id="element-76" />

          <p className="font-['DM_Sans'] text-lg md:text-xl text-[#334155] leading-relaxed" data-id="element-77">
            Sientes que has fallado, que eres la única que no puede controlarlo
            y que el cansancio te está robando los mejores momentos de tu
            maternidad.{' '}
            <span className="font-semibold text-[#0f172a]" data-id="element-78">
              Pero no es tu culpa: te han enseñado métodos que van en contra de
              la biología de tu bebé.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}